import { NgModule } from '@angular/core';
import {
  AcknowledgementModule,
  FormArrayAuthorizedPersonnelModule,
  FormArrayBeneficialOwnerModule,
  FormArrayBoardResolutionModule,
  FormArrayCrsForEntityModule,
  FormArrayCrsModule,
  FormArrayUsPersonModule,
  ReviewBoardResolutionModule,
} from './field-type';
import { FormValidationModule } from './validation/form-validation.module';
import {
  registerAppointmentPreset,
  registerAreaUnitPreset,
  registerBoardResolutionModePreset,
  registerBusinessActivityPreset,
  registerBusinessConstitutionPreset,
  registerBusinessOwnershipPreset,
  registerCountryPreset,
  registerGenderPreset,
  registerHdbTypePreset,
  registerHousingTypePreset,
  registerMaritalStatusPreset,
  registerMinimumAmountReceiveNotificationPreset,
  registerMobileAreaCodePreset,
  registerNationalityPreset,
  registerPassStatusPreset,
  registerPassTypePreset,
  registerPersonnelPreset,
  registerPreferredTimePreset,
  registerPropertyCompletionStatusPreset,
  registerPropertyLandTitlePreset,
  registerPropertyPurposePreset,
  registerPropertyTenurePreset,
  registerPropertyTypePreset,
  registerPropertyUsagePreset,
  registerRacePreset,
  registerResidentialStatusPreset,
  registerTypeOfFinancialPreset,
  registerYesNoPreset,
} from './preset';
import { FORMLY_CONFIG } from '@ngx-formly/core';
import { FormlyPresetModule } from '@ngx-formly/core/preset';

const presetsFn = [
  registerAppointmentPreset,
  registerAreaUnitPreset,
  registerBoardResolutionModePreset,
  registerBusinessActivityPreset,
  registerBusinessConstitutionPreset,
  registerBusinessOwnershipPreset,
  registerCountryPreset,
  registerGenderPreset,
  registerHdbTypePreset,
  registerHousingTypePreset,
  registerMaritalStatusPreset,
  registerMinimumAmountReceiveNotificationPreset,
  registerMobileAreaCodePreset,
  registerNationalityPreset,
  registerPassStatusPreset,
  registerPassTypePreset,
  registerPersonnelPreset,
  registerPreferredTimePreset,
  registerPropertyCompletionStatusPreset,
  registerPropertyLandTitlePreset,
  registerPropertyPurposePreset,
  registerPropertyTenurePreset,
  registerPropertyTypePreset,
  registerPropertyUsagePreset,
  registerRacePreset,
  registerResidentialStatusPreset,
  registerTypeOfFinancialPreset,
  registerYesNoPreset,
] as const;

@NgModule({
  imports: [
    AcknowledgementModule,
    FormArrayAuthorizedPersonnelModule,
    FormArrayBeneficialOwnerModule,
    FormArrayBoardResolutionModule,
    FormArrayCrsForEntityModule,
    FormArrayCrsModule,
    FormArrayUsPersonModule,
    FormValidationModule,
    FormlyPresetModule,
    ReviewBoardResolutionModule,
  ],
  providers: [...presetsFn.map(preset => ({ provide: FORMLY_CONFIG, useFactory: preset, multi: true }))],
})
export class PortalApplicationFormModule {}
